import request from '@/common/js/request';

/**
 * 获取分页数据
 */
export const getPage = (params) => {
    return request('/appversion/listPage',{
        params,
        method: 'get'
    })
}
/**
 * 查询app二维码
 */
export const getLastAppQrCode = (params) => {
    return request('/appversion/getLastAppQrCode',{
        params,
        method: 'get'
    })
}
/**
 * 保存数据
 */
export const save = (data) => {
    return request('/appversion/save',{
        data: data,
        method: 'post'
    })
}
/**
 * 删除
 */
export const deleteById = (params) => {
    return request('/appversion/delete',{
        params: params,
        method: 'DELETE'
    })
}
